import { Control, Controller } from "react-hook-form";
import {
    CircularProgress,
    FormHelperText,
    FormLabel,
    InputAdornment,
    MenuItem,
    Stack,
    StandardTextFieldProps,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import controlledTextFieldStyles from "./ControlledTextField.styles";
import TextFieldWithMask from "./TextFieldWithMask";
import React, {ReactNode} from "react";
import NumberFormat from 'react-number-format';

// import clsx from "clsx";

export interface ControlledTextFieldProps extends StandardTextFieldProps {
    control: Control<any>,
    options?: any[],
    selectNotNulleable?: boolean
}

export interface ControlledTextFieldProps extends StandardTextFieldProps {
    control: Control<any>,
    options?: any[],
    phone?: boolean,
    currency?: boolean,
    percentage?: boolean,
    fixedDecimals?: boolean,
    renderOpt?: ReactNode,
    textAlign?: CanvasTextAlign,
    mask?: string,
    firstOpDefault?: boolean
}

export const ControlledTextField = ({ size, type, selectNotNulleable, ...props }: ControlledTextFieldProps) => {
    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <>
                    <TextField
                        {...props}
                        size={size ?? 'small'}
                        onChange={onChange}
                        value={type === 'number' ? +value : !props.select ? value || '' : (!props.options || !value ? 0 : value)}
                        type={type ?? 'text'}
                        error={!!error}
                        InputProps={{
                            inputComponent: props.currency ? NumberFormatCustom as any : 'input',
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {(!props.options && props.select) && <CircularProgress size={25} />}
                                </InputAdornment>
                            ),
                            ...props.InputProps
                        }}
                        {...props}
                    >
                        {(props.select && !selectNotNulleable) && <MenuItem value={0} />}
                        {
                            (props.options && props.select) &&
                            props.options.map((option) => (
                                <MenuItem key={option.id} value={option.id}>{option.descripcion}</MenuItem>
                            ))
                        }
                    </TextField>

                    {error &&
                        <FormHelperText sx={{ color: 'error.main' }}>
                            {error.message}
                        </FormHelperText>
                    }
                </>
            )}
        />
    )
}


interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    prefix?: string;
}

// @ts-ignore
const NumberFormatCustom = React.forwardRef<NumberFormat, CustomProps>(
    function NumberFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator="."
                decimalSeparator=","
                isNumericString
                prefix={props?.prefix || "$"}
            />
        );
    },
);

export const ControlledTextFieldFilled = ({ /*helperText,*/ label, required, type, ...props }: ControlledTextFieldProps) => {

    const theme = useTheme();
    const classes = controlledTextFieldStyles(theme);

    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Stack sx={{ width: '100%' }}>
                    <FormLabel

                    // className={
                    //     clsx(classes.labelFilled, { [classes.labelFilledDisabled]: props.disabled })
                    // }
                    >
                        <Stack direction="row"
                            justifyContent="flex-start"
                            spacing={1}
                        >
                            <>
                                {label}
                                <Typography color={'text.disabled'} ml={'4px'} fontSize={'0.9rem'}>{`${required ? "*" : ''}`}</Typography>
                            </>

                        </Stack>
                    </FormLabel>
                    <TextField
                        {...props}
                        variant="outlined"

                        // className={classes.textFilled}
                        sx={{
                            ...classes.textFilled
                        }}
                        size="small"
                        value={type === 'number' ? +value : !props.select ? value : (!props.options || !value ? 0 : value)}
                        onChange={onChange}
                        error={!!error}
                        placeholder={props.placeholder || (props.phone ? '(11) 94444-2222' : undefined)}
                        defaultValue={
                            props.defaultValue ? props.defaultValue :
                                !props.select ? value : (!props.options ? 0 : value)
                        }
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                            },
                        }}
                        InputProps={{

                            // inputComponent:
                            //     (props.currency || type === 'number' || props.percentage) ? NumberFormatCustom as any :
                            //         (!!props.identification) ? IdentificationTextMaskCustom as any :
                            //             props.phone ? PhoneNumberMaskCustom as any : 'input',
                            inputProps: {
                                ...props.InputProps?.inputProps,
                                currency: props.currency,
                                style: { textAlign: props.textAlign },
                                percentage: props.percentage,
                                prefix: props.prefix,
                                fixed: props.fixedDecimals,
                            },
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {(!props.options && props.select) && <CircularProgress size={25} />}
                                </InputAdornment>
                            ),
                            ...props.InputProps
                        }}
                        InputLabelProps={{
                            shrink:
                                type === 'number' ? value + 1
                                    : value !== 0 ? value ?? undefined : !props.select,
                            ...props.InputLabelProps,
                        }}
                    >
                        {
                            ((props.select) && (!props.firstOpDefault)) &&
                            <MenuItem value={0}

                                // className={classes.menuItemSelect}
                                sx={{
                                    ...classes.menuItemSelect,
                                }}
                                disableRipple
                            />
                        }
                        {
                            (props.options && props.select) && (
                                props.renderOpt ? props.renderOpt :
                                props.options.map((option) => (
                                    <MenuItem key={option.id}
                                        value={option.id}
    
                                        // className={classes.menuItemSelect}
                                        sx={{
                                            ...classes.menuItemSelect,
                                        }}
                                        disableRipple
                                    >
                                        {option.descripcion}
                                    </MenuItem>
                                ))
                            )
                        }
                    </TextField>

                    {/* {error && <HelperInputText text={error.message} error />}

                    {(helperText && !error) && <HelperInputText text={helperText} />} */}
                </Stack>
            )}
        />
    )
};


export const ControlledTextFieldWithMask = ({ size, type, selectNotNulleable, ...props }: ControlledTextFieldProps) => {
    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value } }) => (
                <TextFieldWithMask {...props}
                                   size={size ?? 'small'}
                                   onChange={onChange}
                                   value={type === 'number' ? +value : !props.select ? value : (!props.options || !value ? 0 : value)}
                                   type={type ?? 'text'}
                                   mask={props.mask}
                                   InputProps={{
                                       endAdornment: (
                                           <InputAdornment position='end'>
                                               {(!props.options && props.select) && <CircularProgress size={25} />}
                                           </InputAdornment>
                                       ),
                                       ...props.InputProps
                                   }}
                                   {...props}
                >
                    {(props.select && !selectNotNulleable) && <MenuItem value={0} />}
                    {
                        (props.options && props.select) &&
                        props.options.map((option) => (
                            <MenuItem key={option.id} value={option.id}>{option.descripcion}</MenuItem>
                        ))
                    }
                </TextFieldWithMask>
            )}
        />
    )
}
